/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const toggleMfaPostRequestSchema = z.object({
  client: z.string(),
  client_secret: z.string(),
  enable: z.string(),
  password: z.string(),
});
